import { Command, Option } from "clipanion";
import { M8tCommand } from "../lib/m8t-command.js";
import { resolveLocalContext } from "../lib/local-context.js";
import {
  colors,
  renderJson,
  renderKeyValueBlock,
  resolveOutputMode,
} from "../lib/output.js";

export class StatusCommand extends M8tCommand {
  static paths = [["status"]];
  static usage = Command.Usage({
    description: "Show the local m8t context: identity, config.yaml, gateway cache, azd mode.",
  });

  output = Option.String("--output");

  async executeCommand(): Promise<number> {
    const mode = resolveOutputMode(
      this.output as "pretty" | "json" | "auto" | undefined,
      this.context.stdout as NodeJS.WriteStream,
    );
    const ctx = await resolveLocalContext();

    if (mode === "json") {
      this.context.stdout.write(renderJson(ctx) + "\n");
      return 0;
    }

    const block = renderKeyValueBlock([
      { key: "az upn", value: ctx.az?.upn ?? colors.dim("(not signed in)") },
      { key: "az tenant", value: ctx.az?.tenantId ?? "-" },
      {
        key: "az subscription",
        value: ctx.az ? `${ctx.az.subscriptionId} (${ctx.az.subscriptionName})` : "-",
      },
      { key: "config tenant", value: ctx.foundry?.tenantId ?? colors.dim("(no config.yaml)") },
      { key: "config clientId", value: ctx.foundry?.clientId ?? "-" },
      { key: "config project", value: ctx.foundry?.projectName ?? "-" },
      { key: "config endpoint", value: ctx.foundry?.projectEndpoint ?? "-" },
      {
        key: "tenant aligned",
        value: ctx.tenantAligned
          ? colors.success("yes ✓")
          : colors.dim("no — config.yaml tenant vs az tenant differ"),
      },
      {
        key: "gateway cache",
        value: ctx.gatewayCache?.gatewayUrl ?? colors.dim("none — discovers on next command"),
      },
      { key: "azd follows az", value: ctx.azdFollowsAz ? "yes" : "no" },
    ]);
    this.context.stdout.write(block + "\n");
    return 0;
  }
}
